<template>
    
    <spinner v-if="!loaded" ></spinner>

    <div class="template-padding" v-else-if="loaded" > 
        <div class="row" >
            <div class="col-12" >
                <b-input-group>
                    <b-form-input v-model="filter" placeholder="Search integrations" class="search-input atlass-input-borderless" />
                    <font-awesome-icon icon="times-circle" @click="filter = ''" class="reset-filter" v-bind:class="{ 'd-none' : !filter }" >Clear</font-awesome-icon>
                </b-input-group>
            </div>
        </div>
        
        <vue-good-table
            class="mb-5"
            :columns="columns"
            :rows="rows"
            styleClass="vgt-table atlass-datatable integrations-table"
            :search-options="{ enabled: true, externalQuery: filter }"
            :pagination-options="{ 
                enabled: false,
                perPage: 20,
                perPageDropdown: [50, 100],
                ropdownAllowAll: true,
                nextLabel: 'next',
                prevLabel: 'prev',
                rowsPerPageLabel: 'Leads per page',
                ofLabel: 'of',
                pageLabel: 'page', // for 'pages' mode
                allLabel: 'All',
            }"
            :selectOptions="{
                enabled: false,
                selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
              }"
            :group-options="{
                enabled: true
            }"
            @on-row-click="openIntegration"
             >
            
            <template slot="table-row" slot-scope="props">
                
                <span v-if="props.column.field == 'Name'">
                    <h5> {{ props.row.Name }} </h5>
                    <p> {{ props.row.Description }} </p>
                </span>
                
                <span v-else-if="props.column.field == 'Icon'">
                    <span class="tablecell-icon" v-if="props.row.Icon == 'FACEBOOK'" > <img src="@/assets/icons/facebook.png" /> </span>
                    <span class="tablecell-icon" v-if="props.row.Icon == 'ADWORDS'" > <img src="@/assets/icons/googleadwords.png" />  </span>
                    <span class="tablecell-icon" v-if="props.row.Icon == 'TIKTOK'" > <img src="@/assets/icons/tiktok.png" />  </span>
                    <span class="tablecell-icon" v-if="props.row.Icon == 'LINKEDIN'" > <img src="@/assets/icons/linkedin.png" />  </span>
                    
                    <span class="tablecell-icon" v-if="props.row.Icon == 'WOOCOMMERCE'" > <img src="@/assets/icons/woocommerce.png" /> </span>
                    <span class="tablecell-icon" v-if="props.row.Icon == 'OPENCART'" > <img src="@/assets/icons/opencart.png" /> </span>
                    <span class="tablecell-icon" v-if="props.row.Icon == 'SHOPIFY'" > <img src="@/assets/icons/shopify.png" /> </span>
                    <span class="tablecell-icon" v-if="props.row.Icon == 'MAGENTO'" > <img src="@/assets/icons/magento.png" /> </span>
                    <span class="tablecell-icon" v-if="props.row.Icon == 'PRESTASHOP'" > <img src="@/assets/icons/prestashop.png" /> </span>
                    
                    <span class="tablecell-icon" v-if="props.row.Icon == 'CLICKFUNNELS'" > <img src="@/assets/icons/clickfunnels.png" /> </span>
                    <span class="tablecell-icon" v-if="props.row.Icon == 'ZAPIER'" > <img src="@/assets/icons/zapier.png" /> </span>
                    
                    <span class="tablecell-icon" v-if="props.row.Icon == 'STRIPE'" > <img src="@/assets/icons/stripe.png" /> </span>
                    
                    <span class="tablecell-icon" v-if="props.row.Icon == 'MAILCHIMP'" > <font-awesome-icon :icon="['fab', 'mailchimp']" /> </span>
                    <span class="tablecell-icon" v-if="props.row.Icon == 'ACTIVECAMPAIGN'" > <img src="@/assets/icons/activecampaign.png" /> </span>
                    <span class="tablecell-icon" v-if="props.row.Icon == 'SENDGRID'" > <img src="@/assets/icons/sendgrid.png" /> </span>
                    <span class="tablecell-icon" v-if="props.row.Icon == 'DRIP'" > <img src="@/assets/icons/drip.png" /> </span>
                    <span class="tablecell-icon" v-if="props.row.Icon == 'GETRESPONSE'" > <img src="@/assets/icons/getresponse.png" /> </span>
                    
                </span>
                
                <span v-else-if="props.column.field == 'Status'">
                    <span v-if="props.row.Status == -2" > <font-awesome-icon :icon="['fa', 'wrench']" /> In planning </span>
                    <span v-if="props.row.Status == -1" > <font-awesome-icon :icon="['fa', 'wrench']" /> In Beta </span>
                    <span v-if="props.row.Status == 0" > <font-awesome-icon :icon="['fa', 'circle']" /> Inactive  </span>
                    <span v-if="props.row.Status == 1" > <font-awesome-icon :icon="['fa', 'check-circle']" class="color-green" /> Active  </span>
                </span>
                
                <span v-else  >
                  {{props.formattedRow[props.column.field]}}
                </span>
                
            </template>
            
        </vue-good-table>
          
        
         <modal :modalData="modalData" :modalState="modalState" modalComponent="product" modalClass="narrow" ></modal>
        
    </div>
</template>

<script>

import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
    
import modal from '@/components/modal.vue'   
import helper from '@/helpers/helpers.js';
    
export default{
    name: "Integrations",
    components:{
        modal
    },
    data () {
        return {
            filter: '',
            columns: [
                {
                    label: '',
                    field: 'Icon',
                    sortable: false,
                    html: true,
                    width: '80px',
                    tdClass: 'icon-cell text-center',
                },
                {
                    label: 'NAME',
                    field: 'Name'
                },
                {
                    label: 'TYPE',
                    field: 'Type',
                    hidden: true,
                },
                {
                    label: 'STATUS',
                    field: 'Status'
                },
                {
                    label: 'CREATED',
                    field: 'datetime',
                    formatFn: this.returnDate,
                    tdClass: 'text-right',
                },
            ],
            rows: [
                {
                    mode: 'span', // span means this header will span all columns
                    label: 'Email', // this is the label that'll be used for the header
                    html: false, // if this is true, label will be rendered as html
                    children: [
                        {
                            "ID": 'new',
                            "Type": "email",
                            "Label": "Email",
                            "APP": "MAILCHIMP",
                            "Name": "Mailchimp",
                            "Description": "Syncronize leads with Mailchimp and get data from campaigns in order to analyze sales",
                            "Icon": 'MAILCHIMP',
                            "Status": 0,

                        },
                        {
                            "ID": 'new',
                            "Type": "email",
                            "Label": "Email",
                            "APP": "ACTIVECAMPAIGN",
                            "Name": "Active Campaign",
                            "Description": "Syncronize leads with Active Campaign and get data from campaigns in order to analyze sales",
                            "Icon": 'ACTIVECAMPAIGN',
                            "Status": 0,

                        },
                        {
                            "ID": 'new',
                            "Type": "email",
                            "Label": "Email",
                            "APP": "SENDGRID",
                            "Name": "SendGrid",
                            "Description": "Syncronize leads with SendGrid and retarget them using automation emails",
                            "Icon": 'SENDGRID',
                            "Status": 0,

                        },
                        {
                            "ID": 'new',
                            "Type": "email",
                            "Label": "Email",
                            "APP": "DRIP",
                            "Name": "Drip",
                            "Description": "Syncronize leads with Drip and retarget them using automation emails",
                            "Icon": 'DRIP',
                            "Status": 0,

                        },
                        /*
                        {
                            "ID": 'new',
                            "Type": "email",
                            "Label": "Email",
                            "APP": "GETRESPONSE",
                            "Name": "GetResponse",
                            "Description": "Syncronize leads with GetResponse and get data from campaigns in order to analyze sales",
                            "Icon": 'GETRESPONSE',
                            "Status": 0,
                         },
                         */
                    ]
                },
                
                {
                    mode: 'span', // span means this header will span all columns
                    label: 'Ads Manager', // this is the label that'll be used for the header
                    html: false, // if this is true, label will be rendered as html
                    children: [
                        {
                            "ID": 'new',
                            "Type": "ads",
                            "Label": "Ads manager",
                            "Name": "Facebook",
                            "Description": "Syncronize and attribute sales from Facebook ads manager and analyze clicks, ad spent and income",
                            "Icon": 'FACEBOOK',
                            "APP": 'FACEBOOK',
                            "Status": 0,
                        },
                        {
                            "ID": 'new',
                            "Type": "ads",
                            "Label": "Ads manager",
                            "Name": "Google AdWords",
                            "Description": "Syncronize and attribute sales from AdWords ads manager and analyze clicks, ad spent and income",
                            "Icon": 'ADWORDS',
                            "APP": 'ADWORDS',
                            "Status": 0,
                        },
                        {
                            "ID": 'new',
                            "Type": "ads",
                            "Label": "Ads manager",
                            "Name": "TikTok",
                            "Description": "Syncronize and attribute sales from TikTok ads manager and analyze clicks, ad spent and income",
                            "Icon": 'TIKTOK',
                            "APP": 'TIKTOK',
                            "Status": 0,
                        },
                        {
                            "ID": 'new',
                            "Type": "ads",
                            "Label": "Ads manager",
                            "Name": "Linkedin",
                            "Description": "Syncronize and attribute sales from Linkedin ads manager and analyze clicks, ad spent and income",
                            "Icon": 'LINKEDIN',
                            "APP": 'LINKEDIN',
                            "Status": -2,
                        },
                    ]
                },
                
                {
                    mode: 'span', // span means this header will span all columns
                    label: 'Ecommerce', // this is the label that'll be used for the header
                    html: false, // if this is true, label will be rendered as html
                    children: [
                        {
                            "ID": 'new',
                            "Type": "ecommerce",
                            "Label": "Ecommerce",
                            "Name": "WooCommerce",
                            "Description": "Syncronize sales from your WooCommerce store",
                            "Icon": 'WOOCOMMERCE',
                            "APP": 'WOOCOMMERCE',
                            "Status": 0,
                        },
                        {
                            "ID": 'new',
                            "Type": "ecommerce",
                            "Label": "Ecommerce",
                            "Name": "OpenCart",
                            "Description": "Syncronize sales from your OpenCart store",
                            "Icon": 'OPENCART',
                            "APP": 'OPENCART',
                            "Status": 0,
                        },
                        {
                            "ID": 'new',
                            "Type": "ecommerce",
                            "Label": "Ecommerce",
                            "Name": "Shopify",
                            "Description": "Syncronize sales from your Shopify store",
                            "Icon": 'SHOPIFY',
                            "APP": 'SHOPIFY',
                            "Status": 0,
                        },
                        {
                            "ID": 'new',
                            "Type": "ecommerce",
                            "Label": "Ecommerce",
                            "Name": "Magento",
                            "Description": "Syncronize sales from your Magento store",
                            "Icon": 'MAGENTO',
                            "APP": 'MAGENTO',
                            "Status": -2,
                        },
                        {
                            "ID": 'new',
                            "Type": "ecommerce",
                            "Label": "Ecommerce",
                            "Name": "PrestaShop",
                            "Description": "Syncronize sales from your PrestaShop store",
                            "Icon": 'PRESTASHOP',
                            "APP": 'PRESTASHOP',
                            "Status": -2,
                        },
                    ]
                },
                
                {
                    mode: 'span', // span means this header will span all columns
                    label: 'Payment processors', // this is the label that'll be used for the header
                    html: false, // if this is true, label will be rendered as html
                    children: [
                        
                    ]
                },
                
                {
                    mode: 'span', // span means this header will span all columns
                    label: 'Checkouts', // this is the label that'll be used for the header
                    html: false, // if this is true, label will be rendered as html
                    children: [
                        {
                            "ID": 'new',
                            "Type": "checkout",
                            "Label": "Checkout",
                            "Name": "Clickfunnels",
                            "Description": "Syncronize sales from your Clickfunnels account",
                            "Icon": 'CLICKFUNNELS',
                            "APP": 'CLICKFUNNELS',
                            "Status": 0,
                        },
                    ]
                },
                
                {
                    mode: 'span', // span means this header will span all columns
                    label: 'Payment Processors', // this is the label that'll be used for the header
                    html: false, // if this is true, label will be rendered as html
                    children: [
                        {
                            "ID": 'new',
                            "Type": "payment_processor",
                            "Label": "Payment Processors",
                            "Name": "Stripe",
                            "Description": "Syncronize sales from your Stripe account",
                            "Icon": 'STRIPE',
                            "APP": 'STRIPE',
                            "Status": 0,
                        },
                    ]
                },
                
                {
                    mode: 'span', // span means this header will span all columns
                    label: 'Bridges', // this is the label that'll be used for the header
                    html: false, // if this is true, label will be rendered as html
                    children: [
                        {
                            "ID": 'new',
                            "Type": "bridge",
                            "Label": "Bridges",
                            "Name": "Zapier",
                            "Description": "Use Zapier to syncronize sales from other apps",
                            "Icon": 'ZAPIER',
                            "APP": 'ZAPIER',
                            "Status": 0,
                        },
                    ]
                },
                
                
            ],
            ActiveIntegrations: [],
            loaded: false,
            modalData: null,
            modalState: false,
            loggedOrgID: null,
        }
    },
    beforeCreate: function (){
       // this.$store.dispatch(GET_USERS);
        
        
    },
    mounted: function(){
        
        this.loggedOrgID = helper.getLoggedInOrganization( this.$store.getters.isAdmin )
        this.get_data();
    
        //console.log(this.rows)
        
    },
    computed: {
    },
    methods: {
        get_data(){

            const db = firebase.firestore();
            var ref = db.collection('organizations/'+this.loggedOrgID+'/integrations')

            return ref.get()
                .then((snapshot) => {
                    let results = [];
                    return Promise.all(
                        snapshot.docs.map(doc => {  
                                let item = {};                
                                item = doc.data(); // will have 'todo.title'
                                item.ID = doc.id;
                                
                                results.push(item);     
                                
                                this.rows.forEach( (group) => {
                                    group.children.forEach((integration)=>{
                                        if( item.APP == integration.APP ){
                                            //console.log("Active integration: "+ JSON.stringify(item))
                                            integration.ID = item.ID
                                            integration.Status = item.Status
                                            integration.datetime = item.datetime
                                        }
                                    })
                                })                                
                            
                                //results.sort((a, b) => b.datetime - a.datetime);
                            
                                this.ActiveIntegrations = results


                                return results; 
                                
                        })
                        
                    )
                    .then(results => {                        
                        //console.log(results)
                        this.loaded = true;
                        return results;   
                        //return results.length > 0 ? results[results.length - 1] : [];
                        
                    })
                
                })
            
        },
        openIntegration(params){
            
            let user =  Cookies.get('user')
            user = JSON.parse( atob( user ) )
            
            let page = params.row.Icon;
            let ID = params.row.ID;
            
            if( ( params.row.Status < 0 && this.$store.getters.getRole == 0 ) || params.row.Status >= 0 || user.email.includes('theatlass.com') || user.test_account == true ){
                this.$router.push({
                    name: "Integration",
                    params: { APP: page }
                }); 
            }
            
        },
        
        returnName(a){
            return a.firstname + " " + a.lastname;
        },
        returnDate(a){
            //return this.$moment.unix(a).format( 'MMM D, HH:mm' )
            return helper.formatDate( a, 'MMM D, HH:mm' )
        },
        renderStatus(a){
            var r;
            
            if( a.Status == 1 ){
                r = 'Active';
            }else if( a.Status == 0 ){
                r = 'Inactive';
            }else if( a.Status == 2 ){
                r = 'Blocked';
            }else if( a.Status == 3 ){
                r = 'Manually blocked';
            }
            
            return r;
        },
        routeRow(id){
            this.fModalOpen( id );
        },
        deleteRow(id){
            //this.fModalOpen( params.row.id );
            this.PreventDelete(id)
        },
        CreateItem(){
            this.fModalOpen( null );
            
        },
        fModalOpen( data ){
            this.modalState = true;
            this.modalData = data
        },
        PreventDelete( ID ){
            
            this.$swal({
                title: 'Are you sure?',
                text: 'This cannot be undone',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.value) { 
                    
                    this.deleteProduct(ID);
                    
                }
            })
            
        },        
        deleteProduct: function(ID){
            
            this.loaded = false
            
            const db = firebase.firestore();
            let ref = db.collection('organizations/'+this.loggedOrgID+'/products').doc( ID )
            return ref.delete()
                .then(function(){
                
                     this.$toast.success({
                        title: 'Success',
                        message: 'Product deleted'
                    })

                    setTimeout(function(){ 
                        this.loaded = true
                        this.get_data();
                        this.modalData = null
                        this.modalState = false
                    }.bind(this), this.timeout );
                
                }.bind(this))
                .catch(function(error){
                
                    //console.error("Error updating document: ", error);
                    this.$toast.error({
                        title: 'Error',
                        message: "Something went wrong: "+error
                    })
                
                    this.loaded = true
                
                }.bind(this))
        }
    },
    computed:{
        isAdmin(){
            if( !this.$store.getters.getLoggedInOrganization  ){
                return this.$store.getters.isAdmin
            }else{
                return false
            }
            
        },
    },
}
</script>

<style scoped="" >

</style>


// WEBPACK FOOTER //
// src/templates/setup/Integrations.vue